module.exports = "<div> <div class=\"divider-group dg-no-top-border\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>{%- item.cdmMeaning %}</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12\"> <div class=row> <div class=col-md-2> {%= isOn %} </div> <div class=\"col-md-10 q-marg-top-xxxs\"> {%- item.cdmDescription %} </div> </div> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/facilities/html/classificationTypes.html
// module id = 1292
// module chunks = 1